import { render } from "./CheckSvg.vue?vue&type=template&id=6f708f5f&ts=true"
import script from "./CheckSvg.vue?vue&type=script&lang=ts"
export * from "./CheckSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__